import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalPriceSheetActivity = ({ event, actionLabel }: { event: any; actionLabel: string }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> {actionLabel}
    </Box>
  );
};

export default SabalPriceSheetActivity;
